<template>
    <div>
        <div class="header">
            <div class="common-header">
                <div class="common-header-right">
                    <div class="common-header-block">
                        <el-input
                                placeholder="输入用户ID查询"
                                v-model="searchVal">
                            <template slot="prepend">用户ID</template>
                        </el-input>
                    </div>
                    <div class="common-header-block">
                        数据类型：
                        <el-select
                                style="width: 120px"
                                v-model="simulatorCondition">
                            <el-option
                                    v-for="item in simulatorConditionOptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="common-header-block">
                        <el-checkbox
                                v-model="imeiCondition"
                                :true-label="1"
                                :false-label="0"
                                label="IMEI" border/>
                    </div>
                    <div class="common-header-block">
                        <el-checkbox
                                v-model="ipCondition"
                                :true-label="1"
                                :false-label="0"
                                label="IP" border/>
                    </div>
                    <div class="common-header-block">
                        <el-button type="primary" @click="searchUserRelevance">搜索关联账号</el-button>
                        <el-button type="success" @click="exportFunc">导出关联账号</el-button>
                    </div>
                </div>
            </div>

            <div class="common-search">
                <div class="common-header-block">
                    <el-input v-model="clubRandomId" placeholder="请输入俱乐部ID">
                        <template slot="prepend">俱乐部ID</template>
                    </el-input>
                </div>
                <div class="common-header-block">
                    <el-date-picker
                            v-model="date"
                            format="yyyy-MM-dd HH:mm"
                            type="datetimerange"
                            value-format="yyyy-MM-dd HH:mm"
                            range-separator="-"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"/>
                </div>
                <div class="common-header-block">
                    <el-button type="primary" @click="searchUserStats()">搜索牌局信息</el-button>
                </div>
            </div>
        </div>
        <div v-loading="loading" class="common-table">
            <el-table :data="userRelevanceList" @selection-change="selectUser = $event">
                <el-table-column type="selection"/>
                <el-table-column width="130">
                    <template slot="header">
                        <el-button @click="searchUserRelevanceTotal" size="mini" type="primary" plain>查询关联总数</el-button>
                    </template>
                </el-table-column>
                <el-table-column label="编号" align="center" type="index"/>
                <el-table-column label="用户号" align="center" prop="userId"/>
                <el-table-column label="用户昵称" align="center" prop="nickName"/>
                <el-table-column label="IMEI" align="center" prop="imeiData"/>
                <el-table-column label="IP" align="center">
                    <template slot-scope="scope">
                        <template v-for="(item,index) of scope.row.ipData">
                            {{index===0?'':','}}{{item}}
                        </template>
                    </template>
                </el-table-column>
            </el-table>
            <table class="table">
                <tr>
                    <td>关联总带入：</td>
                    <td v-text="userRelevance.totalBring"></td>
                    <td>关联总保险：</td>
                    <td v-text="userRelevance.totalInsurance"></td>
                    <td>关联总盈亏：</td>
                    <td v-text="userRelevance.totalIntegral"></td>
                    <td>关联总手数：</td>
                    <td v-text="userRelevance.totalHands"></td>
                </tr>
                <tr>
                    <td>总带入：</td>
                    <td v-text="userStats.totalBring"></td>
                    <td>总保险：</td>
                    <td v-text="userStats.totalInsurance"></td>
                    <td>总盈亏：</td>
                    <td v-text="userStats.totalIntegral"></td>
                    <td>总手数：</td>
                    <td v-text="userStats.totalHands"></td>
                </tr>
            </table>

            <el-table
                    :data="userStats.beanList"
                    :row-key="row=>JSON.stringify(row)" height="70vh">
                <el-table-column label="编号" type="index" align="center"/>
                <el-table-column label="俱乐部号" align="center" prop="clubRandomId"/>
                <el-table-column label="俱乐部名称" width="150" align="center" prop="clubName"/>
                <el-table-column label="用户ID" align="center" prop="userRandomId"/>
                <el-table-column label="用户昵称" align="center" prop="userNickname"/>
                <el-table-column label="房间ID" align="center" prop="roomId"/>
                <el-table-column label="房间名称" align="center" prop="roomName"/>
                <el-table-column label="保险池" align="center" prop="insurancePool"/>

                <el-table-column label="总带入" align="center" prop="totalBring"/>
                <el-table-column label="手数" align="center" prop="totalHands"/>
                <el-table-column label="盈亏" align="center" prop="integral"/>
                <el-table-column label="大小盲" align="center" prop="blind"/>
                <el-table-column label="结束时间" align="center" prop="endTime"/>
                <el-table-column label="是否开启保险" width="150" align="center">
                    <template slot-scope="scope">{{scope.row.insurance?'是':'否'}}</template>
                </el-table-column>
            </el-table>

            <el-pagination
                    class="common-el-pagination"
                    layout="prev,pager,next,jumper"
                    background
                    :page-size="20"
                    :pager-count="5"
                    :total="userStats.total"
                    :current-page="currentPage"
                    @current-change="searchUserStats({page:$event})"/>
        </div>
    </div>
</template>
<script>
    import {mapMutations, mapActions} from 'vuex'
    export default {
        data() {
            return {
                loading: false,
                date: null,
                searchVal: null,
                selectUser: [],
                imeiCondition: 0,
                ipCondition: 0,
                simulatorCondition: '2',
                simulatorConditionOptions: [
                    {label: '全部', value: '2'},
                    {label: '真机数据', value: '0'},
                    {label: '模拟器数据', value: '1'},
                ],
                userRelevance: {//关联账号
                    totalBring: 0,
                    totalHands: 0,
                    totalInsurance: 0,
                    totalIntegral: 0,
                },
                userRelevanceList: [],// 关联用户列表
                clubRandomId: '',// 俱乐部随机id
                coefficient: '1', // 百分比
                userStats: {// 用户牌局信息
                    beanList: [],
                    total: 0,
                    totalBring: 0,// 总带入
                    totalInsurance: 0,// 总保险
                    totalIntegral: 0,// 总盈亏
                    totalHands: 0,// 总手数
                    coefficientSum: 0,// 总数累计值
                },
                currentPage: 1
            }
        },
        methods: {
            ...mapMutations('other', ['setStateDownloadConfig']),
            ...mapActions('gameDetail', ['getUserStats']),
            ...mapActions('dataManage', ['getUserRelevance', 'getUserRelevanceTotal']),
            parameterCalibration() {
                if (!this.searchVal) {
                    this.$message.error('请输入用户ID');
                    return false
                }
                return true
            },
            searchUserRelevance() {
                if (!this.parameterCalibration()) return;
                this.loading = true;
                let params = {
                    randomId: this.searchVal,
                    imeiCondition: this.imeiCondition,
                    ipCondition: this.ipCondition,
                    simulatorCondition: this.simulatorCondition,
                };
                this.getUserRelevance(params).then(res => {
                    this.userRelevanceList = res.data.secondDatas;
                    this.userRelevance = {//关联账号
                        totalBring: 0,
                        totalHands: 0,
                        totalInsurance: 0,
                        totalIntegral: 0,
                    };
                    this.loading = false;
                })
            },
            searchUserStats(obj = {}) {
                if (!this.parameterCalibration()) return;
                if (!this.date) {
                    this.$message.error('请选择时间');
                    return;
                }
                this.loading = true;
                let params = {
                    userRandomId: this.searchVal,
                    clubRandomId: this.clubRandomId,
                    coefficient: '1',
                    startTime: this.date[0],
                    endTime: this.date[1],
                    page: 1
                };
                Object.assign(params, obj);
                this.currentPage = params.page;
                this.getUserStats(params).then(res => {
                    this.userStats = res.data;
                    this.loading = false;
                })
            },
            searchUserRelevanceTotal() {
                if (!this.selectUser.length){
                    this.$message.error('请选择关联账号');
                    return;
                }

                let userIds = this.selectUser.map(item => item.userId);
                this.getUserRelevanceTotal({
                    userIds,
                    clubRandomId: this.clubRandomId,
                    startTime: this.date && this.date[0] || '',
                    endTime: this.date && this.date[1] || '',
                }).then(res => {
                    this.userRelevance = {
                        totalBring: res.data.totalBring,
                        totalHands: res.data.totalHands,
                        totalInsurance: res.data.totalInsurance,
                        totalIntegral: res.data.totalIntegral,
                    }

                })
            },
            exportFunc() {
                if (!this.parameterCalibration()) return;
                this.setStateDownloadConfig({
                    action: '/data/manage/user/relevance/export',
                    info: [
                        {name: 'imeiCondition', value: this.imeiCondition},
                        {name: 'ipCondition', value: this.ipCondition},
                        {name: 'level', value: 1},
                        {name: 'randomId', value: this.searchVal},
                        {name: 'simulatorCondition', value: this.simulatorCondition},
                    ]
                });
            }
        }
    }
</script>
<style lang="scss" scoped>
    .header {
        position: relative;
        z-index: 1;
        padding: 10px 10px 10px 0;
        margin: -10px -10px 0;
        border: 1px solid $border-color;
        box-shadow: $box-shadow;
    }

    .common-table {
        flex: none;
        overflow: auto;
    }

    .table {
        padding-top: 20px;
        font-weight: bold;
        line-height: 40px;

        td:nth-of-type(even) {
            padding-right: 50px;
        }
    }
</style>